export default {
  'Submit': 'Gửi ',
  'Save': 'Lưu lại',
  'enterOTP': 'Nhập mã xác nhận ',
  'otpSent': 'Đã gửi mã OTP',
  'login/signup': 'Đăng nhập/ Đăng ký ',
  'resendCode': 'Gửi lại mã xác nhận ',
  'edit': 'Chỉnh sửa ',
  'otpMessage': 'Mã xác nhận gồm 6 ký tự đã được gửi đến điện thoại của bạn ',
  'oyo360WelcomeMessage': 'Đăng nhập/ Đăng ký ',
  'oyo360ResendCode': 'Gửi lại mã xác nhận ',
  'oyo360Edit': 'Chỉnh sửa ',
  'oyo360otpMessage': 'Mã xác nhận gồm 6 ký tự đã được gửi đến điện thoại của bạn ',
  'buttonActionContinue': 'Tiếp tục ',
  'chooseLanguage': 'Lựa chọn Ngôn ngữ ',
  'currentLanguage': 'Ngôn ngữ hiện tại ',
  'otherLanguages': 'Ngôn ngữ khác ',
  'google': 'Google',
  'facebook': 'Facebook',
  'or': 'hoặc ',
  'buttonActionSubmit': 'Gửi đi ',
  'welcomeTitle': 'Chào mừng bạn đến với OYO',
  'welcomeHeadingForMailLogin': 'Vui lòng nhập địa chỉ email mà bạn đã đăng ký ',
  'welcomeHeadingForLogin': 'Vui lòng đăng nhập email hoặc số điện thoại đã đăng ký',
  'userNameLabel': 'Địa chỉ email/ số điện thoại',
  'userNameErrorMessage':'Vui lòng nhập địa chỉ email/ số điện thoại đúng',
  'welcomeHeadingForPhoneLogin': 'Vui lòng nhập số điện thoại mà bạn đã đăng ký ',
  'emailIdLabel': 'Email',
  'phoneNumberLabel': 'Số điện thoại ',
  'passwordLabel': 'Mật khẩu ',
  'newPasswordLabel': 'Mật khẩu mới ',
  'confirmNewPasswordLabel': 'Xác nhận mật khẩu mới ',
  'emailErrorMessage': 'Vui lòng nhập địa chỉ email hợp lệ ',
  'phoneNumberErrorMessage': 'Vui lòng nhập số điện thoại hợp lệ ',
  'passwordErrorMessage': 'Vui lòng nhập đúng mật khẩu ',
  'confirmPasswordErrorMessage': 'Sai mật khẩu ',
  'generateNewPassword': 'Tạo mật khẩu mới ',
  'loginButtonLabel': 'Đăng nhập',
  'loginWithPhoneButtonLabel': 'Tiếp tục đăng nhập bằng điện thoại ',
  'loginWithOtp': 'Đăng nhập bằng mã OTP',
  'loginWithEmailButtonLabel': 'Tiếp tục đăng nhập bằng địa chỉ email ',
  'back': 'Trở lại ',
  'loginWithOtpTitle': 'Nhập mã xác nhận ',
  'loginWithOtpHeading': 'Mã xác nhận gồm 6 ký tự đã được gửi đến điện thoại của bạn ',
  'listYourProperty': 'Danh sách khách sạn ',
  'privacyPolicy': 'chính sách bảo mật ',
  'verifyEmail': 'Xác nhận địa chỉ Email',
  'verifyMobile': 'Xác nhận số điện thoại di động ',
  'forgotPasswordPhoneSubHeading': 'Chúng tôi sẽ gửi mã xác nhận gồm 6 ký tự đến điện thoại của bạn để xác minh ',
  'forgotPasswordMailSubHeading': 'Chúng tôi sẽ gửi mã xác nhận gồm 6 ký tự đến địa chỉ Email của bạn để xác minh',
  'newPasswordCondition1': 'Mật khẩu phải bao gồm cả Số và Ký hiệu ',
  'newPasswordCondition2': 'Mật khẩu cần phải có ít nhất 8 ký tự ',
  'newPasswordCondition3': 'Mật khẩu phải bao gồm cả chữ hoa và chữ thường ',
  'confirmLogin': 'Xác nhận và Đăng nhập',
  'getOTP': 'Nhận mã OTP',
  'invalidInput': 'Mã không hợp lệ ',
  'passwordResetMessage': 'Mật khẩu được tạo thành công',
  'otpErrorMessage': 'Vui lòng nhập chính xác mã OTP',
  'resendOtpSuccessMessage': 'Mã OTP đã được gửi lại đến số điện thoại của bạn ',
  'InternalServerErrorMessage': 'Lỗi máy chủ nội bộ',
  'resetPasswordHeading': 'Mã xác nhận gồm 6 ký tự đã được gửi đến email và số điện thoại của bạn',
  'signingIn': 'Đang đăng nhập ',
  'invalidMobileNumber': 'Số điện thoại không hợp lệ ',
  'privacyFooterText':
    'Bằng cách đăng nhập vào tài khoản của bạn, bạn chấp nhận các {termsOfUse} và {privacyPolicy} của chúng tôi',
  'and': 'và',
  'termsOfUse': 'diều khoản sử dụng',
  'listProperty': 'Danh sách khách sạn ',
  'whiteSpace': ' ',
  'errorNoAssociatedHotels':
    'B\u1ea1n kh\u00f4ng c\u00f3 kh\u00e1ch s\u1ea1n n\u00e0o \u0111\u01b0\u1ee3c li\u00ean k\u1ebft',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'passwordChangeInformationText': 'Bạn sẽ đăng xuất khỏi tất cả các thiết bị sau khi thay đổi mật khẩu'
};
